import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Gavel } from 'lucide-react';
import { useAdmin } from '../contexts/AdminContext';

const TABS = [
  { label: 'Dashboard', path: '/admin/dashboard' },
  { label: 'Auction Companies', path: '/admin/auctions' },
  { label: 'Individual Auctioneers', path: '/admin/individual-auctioneers' },
  { label: 'Claim Requests', path: '/admin/claim-requests' },
  { label: 'Listing Requests', path: '/admin/listing-requests' },
  { label: 'Data Sync', path: '/admin/sync' },
  { label: 'Send Emails', path: '/admin/email' },
  { label: 'Deletion Schedule', path: '/admin/deletion' },
];

export const AdminNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { admin, logout } = useAdmin();
  const handleLogout = () => { logout(); navigate('/admin/login'); };

  return (
    <>
      <nav className="bg-white shadow-sm border-b" data-testid="admin-nav">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <button onClick={() => navigate('/admin/dashboard')} className="flex items-center" data-testid="admin-home-btn">
              <Gavel className="w-5 h-5 mr-2 text-blue-600" />
              <h1 className="text-xl font-bold text-gray-900">NetAuctions Admin</h1>
            </button>
            <div className="flex items-center space-x-4">
              {admin?.email && <span className="text-sm text-gray-600 hidden sm:inline">{admin.email}</span>}
              <button onClick={handleLogout} data-testid="admin-logout-btn"
                className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-lg transition">
                Logout
              </button>
            </div>
          </div>
        </div>
      </nav>

      <div className="bg-white border-b overflow-x-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex space-x-6 whitespace-nowrap">
            {TABS.map((t) => {
              const active = location.pathname === t.path;
              return (
                <button key={t.path} onClick={() => navigate(t.path)}
                  data-testid={`admin-tab-${t.path.split('/').pop()}`}
                  className={`py-4 px-1 border-b-2 font-medium text-sm transition ${active ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}>
                  {t.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};
